// extracted by css-extract-rspack-plugin
export default {"footer":"Footer-module__footer__JtM_u"};